export default __webpack_public_path__ + "static/media/oral-history.0e9453fc.png";